import React, {Component, PropTypes} from 'react';
import IconSVG from 'svg-inline-react';
import ActionCreators from 'actions/ActionCreators'
import ga from 'react-ga'
import classnames from 'classnames'
import isMobile from 'ismobilejs'

import './SidebarInfoBlock.scss';

class SidebarInfoBlock extends Component {
    
    static propTypes = {
        title: PropTypes.string,
        isEditable: PropTypes.bool,
        linkToEdit: PropTypes.string,
        className: PropTypes.any,
        showEditAlert: PropTypes.bool,
    };
    
    static defaultProps = {
        title: 'Title',
        isEditable: false,
        linkToEdit: '/',
        className: [],
        showEditAlert: false,
    };
    
    onClick = (e) => {
        e.preventDefault()
        
        if (this.props.showEditAlert && !confirm('Вы действительно хотите изменить заказ? После изменений вам необходимо будет проверить заказ еще раз.')) {
            return false
        }
        
        if (this.props.linkToEdit.indexOf('route') !== -1) {
            ga.event({
                category: 'clicks',
                action: 'instant_booking_edit_route',
                label: this.props.category.name,
                value: 1,
            })
        } else if (this.props.linkToEdit.indexOf('params') !== -1) {
            ga.event({
                category: 'clicks',
                action: 'instant_booking_edit_extra_services',
                label: this.props.category.name,
                value: 1,
            })
        } else {
            ga.event({
                category: 'clicks',
                action: 'instant_booking_edit_cargo',
                label: this.props.category.name,
                value: 1,
            })
        }
        
        const stage = `/category/${this.props.linkToEdit}`
        ActionCreators.setStage(stage)
    }

    renderEditBtn = () => {
        return this.props.isEditable &&
            <a onClick={this.onClick}>
                {!isMobile.phone ?
                    'Изменить'
                    :
                    <IconSVG src={require('!svg-inline!./edit-icon.svg')}/>
                }
            </a>
    }
    
    render() {
        return (
            <section className={classnames('SidebarInfoBlock', this.props.className)}>
                <header className="SidebarInfoBlock-header">
                    <h3>{this.props.title}</h3>
                    {this.renderEditBtn()}
                </header>
                
                <main className="SidebarInfoBlock-main">
                    {this.props.children}
                    <div className="SidebarInfoBlock-editBtn">
                        {this.renderEditBtn()}
                    </div>
                </main>
            </section>
        );
    }
    
}

export default SidebarInfoBlock;



// WEBPACK FOOTER //
// ./client/components/SidebarInfoBlock/SidebarInfoBlock.js